import {createApp} from 'vue'
import UploadNewFileOverlay from './UploadNewFileOverlay'

const el = '.kb-component--upload-new-file-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((UploadNewFileOverlayDOM)=>{
            const component = createApp(UploadNewFileOverlay).use(Store)
            component.mount(UploadNewFileOverlayDOM)
        })
    }
}